import { Injectable } from '@angular/core'

import { StyleLoaderService } from './../core/style-loader/style-loader.service'
import { ScssVariable } from './../core/style-loader/scss-variable'

@Injectable({providedIn: 'root'})
export class AvatarSizeService {

  public validSizes: string[] = []

  constructor(private styleLoaderService: StyleLoaderService) {
    // noop
  }

  public init(): void {
    this.validSizes = this.getValidSizes()
  }

  public getDefaultSize(): string {

    if (this.validSizes.length === 0) {
      this.loadSizesFromStyles()
    }

    return this.validSizes[0]

  }

  public isValid(size: string): boolean {
    return (this.validSizes.indexOf(size) !== -1)
  }

  public getScssVariableValue(): ScssVariable {
    return this.styleLoaderService.getVariable('se-avatar-sizes')
  }

  public loadSizesFromStyles(): void {
    const sizeScssVariableValues = this.getScssVariableValue().value
    this.validSizes = Object.keys(sizeScssVariableValues)
  }

  public getValidSizes(): string[] {

    if (!this.validSizes || this.validSizes.length === 0) {
      this.loadSizesFromStyles()
    }

    return this.validSizes

  }

}
